(() => {
  'use strict';
  const form = document.getElementById('lt-inquiry-form');
  if (!form) return;
  const summary = document.getElementById('lt-inquiry-config');
  const notes = document.getElementById('lt-inquiry-config-notes');
  const company = document.getElementById('lt-company-fields');
  let configuration = { items: [], notes: '', valid: false };
  let configurationReady = false;
  const configError = document.getElementById('lt-inquiry-config-error');
  function acceptConfiguration(value) {
    if (!value || !Array.isArray(value.items)) return;
    configuration = {
      items: value.items.filter(item => item && typeof item.label === 'string').map(item => ({label: item.label, value: String(item.value ?? '')})),
      notes: String(value.notes || ''),
      valid: value.valid === true
    };
    configurationReady = true;
    if (configuration.valid) configError.hidden = true;
    summary.replaceChildren();
    for (const item of configuration.items) {
      const row = document.createElement('div');
      const title = document.createElement('dt');
      const text = document.createElement('dd');
      title.textContent = item.label + ':';
      text.textContent = item.value;
      row.append(title, text);
      summary.append(row);
    }
    notes.hidden = !configuration.notes;
    notes.textContent = 'Configuration notes: ' + configuration.notes;
    updateBody();
  }
  function updateCompany() {
    const isCompany = form.elements['contact[Purchase for]'].value === 'Company / client project';
    company.hidden = !isCompany;
    company.disabled = !isCompany;
    const type = document.getElementById('lt-business-type').value;
    const dealer = type === 'Dealer / distributor';
    const installer = type === 'Installer / contractor';
    const project = type === 'Architect / designer' || type === 'Project developer / commercial owner';
    for (const label of company.querySelectorAll('[data-company-condition]')) {
      const key = label.dataset.companyCondition;
      const visible = isCompany && ({trade: dealer || installer, dealer, installer, project})[key];
      label.hidden = !visible;
      for (const control of label.querySelectorAll('input,select,textarea')) control.disabled = !visible;
    }
    updateBody();
  }
  function updateBody() {
    const lines = ['MOTORIZED PERGOLA ENQUIRY', '', 'SELECTED CONFIGURATION'];
    if (!configuration.items.length) lines.push('Configuration not available; please confirm with the customer.');
    configuration.items.forEach(item => lines.push(item.label + ': ' + item.value));
    if (configuration.notes) lines.push('Configuration notes: ' + configuration.notes);
    lines.push('', 'CONTACT AND PROJECT');
    for (const control of form.elements) {
      if (!control.name.startsWith('contact[') || control.name === 'contact[body]' || control.matches(':disabled')) continue;
      if (['radio', 'checkbox'].includes(control.type) && !control.checked) continue;
      if (control.value.trim()) lines.push(control.name.slice(8, -1) + ': ' + control.value.trim());
    }
    document.getElementById('lt-inquiry-body').value = lines.join('\n');
  }
  form.addEventListener('change', updateCompany);
  form.addEventListener('input', updateBody);
  // Preserve Shopify's native form submission and server-rendered success/errors.
  form.addEventListener('submit', event => {
    if (!configurationReady || !configuration.valid) {
      event.preventDefault();
      configError.textContent = configurationReady
        ? 'Please complete the required configuration fields above before submitting your enquiry.'
        : 'Your configuration is not ready yet. Please wait for the configurator to load and select your options.';
      configError.hidden = false;
      const target = document.querySelector('#configurator, #motorized-configurator, .motorized-configurator, .manual-configurator, .configurator-grid');
      if (target) target.scrollIntoView({behavior: 'smooth', block: 'start'});
      return;
    }
    updateBody();
  });
  form.addEventListener('invalid', event => {
    const details = event.target.closest('details');
    if (details) details.open = true;
  }, true);
  window.addEventListener('lt:configuration', event => acceptConfiguration(event.detail));
  form.querySelector('[data-lt-edit]').addEventListener('click', event => {
    const target = document.querySelector('#configurator, #motorized-configurator, .motorized-configurator, .manual-configurator, .configurator-grid');
    if (target) {event.preventDefault(); target.scrollIntoView({behavior: 'smooth', block: 'start'});}
  });
  updateCompany();
  acceptConfiguration(window.ltConfiguration);
  const feedback = form.querySelector('.lt-inquiry-feedback');
  if (feedback) {feedback.focus(); feedback.scrollIntoView({block: 'center'});}
})();
